import { gql } from '@apollo/client';

import { PayrollExpenseFragment } from './PayrollExpense.graphql';
import { PayrollQreFragment } from './PayrollQre.graphql';
// PROJ_MERGE
/**
 * This is a fragment used to encapsulate the fields used when querying for a payrollExpense plus its relations.
 */
export const GetPayrollExpenseFragment = gql`
  fragment GetPayrollExpense on PayrollExpense {
    ...PayrollExpense
    payrollQre {
      ...PayrollQre
    }
  }
  ${PayrollExpenseFragment}
  ${PayrollQreFragment}
`;
